import { action } from "../common/Action"
import { RapportiControlloClient, CreateRapportoControlloDto } from "../generated";

const service = new RapportiControlloClient();

class RapportiControlloActions {
    @action
    async getByIdImpianto(idImpianto: number) {
        return {
            idImpianto,
            rapportiControllo: (await service.getByImpianto(idImpianto))!,
        }
    };

    @action
    async create(data: CreateRapportoControlloDto) {
        return (await service.create(data))!;
    }

    @action
    async getLastNumber(year: number) {
        return await service.getLastNumber(year);
    }

    @action
    async numberExist(year: number, number: number) {
        return await service.numberExist(year, number);
    }

    @action
    async delete(idImpianto: number, year: number, number: number) {
        const result = await service.delete(year, number);
        return {
            idImpianto,
            year,
            number,
            result
        }
    }
}
export default new RapportiControlloActions();